'use strict';
var base = require('./base');
var focusHelper = require('../components/focus');

const SWIPER_A11Y = {
    prevSlideMessage: 'Slide precedente',
    nextSlideMessage: 'Slide successiva',
    firstSlideMessage: 'Questa è la prima slide',
    lastSlideMessage: 'Questa è l’ultima slide',
    paginationBulletMessage: 'Vai alla slide {{index}}'
};

const cache = {
    $body: $('body')
};

function initializeSwiper() {
    $('.swiper-modal-container-thumbnails').each(function () {
        new Swiper(this, {
            spaceBetween: 10,
            slidesPerView: 3,
            freeMode: true,
            watchSlidesProgress: true,
            modules: [Pagination, Navigation, A11y],
            a11y: SWIPER_A11Y
        });
    });

    $('.swiper-modal-container').each(function () {
        var swiperThumbnails = $(this).closest('.modal-content').find('.swiper-modal-container-thumbnails')[0];
        var thumbsSwiper = swiperThumbnails ? swiperThumbnails.swiper : null;

        new Swiper(this, {
            spaceBetween: 20,
            slidesPerView: 1,
            speed: 400,
            loop: false,
            modules: [Thumbs, Pagination, Navigation, A11y],
            a11y: SWIPER_A11Y,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
        });
    });
}

/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade overflow-mobile" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog modal-xl quick-view-dialog modal-dialog-centered">'
        + '<!-- Modal content mobile-->'
        + '<div class="modal-content d-md-none fixed-bottom topDistance">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right pt-2 pb-1" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer-mobile pt-3"></div>'
        + '</div>'
        +'<!-- Modal content tablet and desktop-->'
        + '<div class="modal-content d-none d-md-block">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right pt-2 pb-1" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer d-md-none"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
        $('body').append(htmlString);
}

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.product-quickView-footer');

    return { body: body, footer: footer };
}

/**
 * Replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('.modal-body').empty();
            $('.modal-body').html(parsedHtml.body);
            $('.modal-footer-mobile').html(parsedHtml.footer);
            $('.full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .quick-view-stored-url').attr('href', data.productUrl);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');

            initializeSwiper();

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

const handleResize = function () {
    if (BreakpointHelper.isDownTo('md')) {
        $quickView.removeClass('show-zoom-image');
        $(window).off('resize', handleResize);
    }
};

module.exports = {
    showQuickview: function () {
        cache.$body.on('click', '.quickview', function (e) {
            e.preventDefault();
            var selectedValueUrl = this.dataset.href;
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);
        });
    },
    focusQuickview: function () {
        cache.$body.on('shown.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal .close').focus();
        });
    },
    trapQuickviewFocus: function () {
        cache.$body.on('keydown', '#quickViewModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    availability: base.availability,
    addToCart: base.addToCart,
    showSpinner: function () {
        cache.$body.on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.modal-content').spinner().start();
        });
    },
    hideDialog: function () {
        cache.$body.on('product:afterAddToCart', function () {
            $('#quickViewModal').modal('hide');
        });
    },
    beforeUpdateAttribute: function () {
        cache.$body.on('product:beforeAttributeSelect', function () {
            $('.modal.show .modal-content').spinner().start();
        });
    },
    updateAttribute: function () {
        cache.$body.on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .full-pdp-link').attr('href', response.data.product.selectedProductUrl);
            }
        });
    },
    updateAddToCart: function () {
        cache.$body.on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.add-to-cart-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order')
                || !$('.global-availability', dialog).data('available')
            );
        });
    },
    updateAvailability: function () {
        cache.$body.on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);


            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    },
    preventNewTab: function() {
        $("a.prevent-new-tab").on("click", function (e) {
            e.preventDefault();
        });
    },
    showQuickViewZoomImage: function() {
        cache.$body.on('click', '#quickViewModal .product-quickview .img-fluid[data-index="1"]', function () {
            const $quickView = $(this).parents('.product-quickview');
            $quickView.addClass('show-zoom-image');

            const handleResize = function () {
                if (BreakpointHelper.isDownTo('md')) {
                    $quickView.removeClass('show-zoom-image');
                    $(window).off('resize', handleResize);
                }
            };

            $(window).on('resize', handleResize);
        });
    },
    backToQuickView: function() {
        cache.$body.on('click', '.back-to-quick-view', function (e) {
            e.preventDefault();
            $(this).parents('.product-quickview').removeClass('show-zoom-image');
        });
    },
    zoomImage: function () {
        cache.$body.on('click', '#quickViewModal .product-quickview .zoomable-img', function (e) {
            const $img = $(this);

            if (!$img.hasClass('zoomed')) {
                $img.addClass('zoomed');
                $img.trigger($.Event('mousemove', {
                    pageX: e.pageX,
                    pageY: e.pageY
                }));
            } else {
                $img.removeClass('zoomed');
                $img.css({
                    'transform-origin': '',
                    'transform': '',
                });
            }
        });

        cache.$body.on('mousemove', '#quickViewModal .product-quickview .zoomable-img', function (e) {
            const $img = $(this);

            if (!$img.hasClass('zoomed')) return;

            const $container = $img.closest('.zoom-image');
            const offset = $container.offset();
            const x = e.pageX - offset.left;
            const y = e.pageY - offset.top;

            const containerWidth = $container.width();
            const containerHeight = $container.height();

            const xPercent = Math.min(100, Math.max(0, (x / containerWidth) * 100));
            const yPercent = Math.min(100, Math.max(0, (y / containerHeight) * 100));

            $img.css({
                'transform-origin': `${xPercent}% ${yPercent}%`,
                'transform': 'scale(2)',
            });
        });
    }
};
